<template>
    <div>
        <ProgressBar mode="indeterminate" style="height: .5em" v-if="progress" />

        <h4>Аналітика</h4>

        <div class="confirm_buttons">
            <div class="catalog-sub-menu nav-item"
                v-if="!sortByGroup"
                @click="isShowBrands = !isShowBrands"
                tabindex="0"
            >
                <div v-if="selectedBrands.length" class="selected_pill"></div>
                <div class="sub_menu_title">
                    <span>Бренд</span>
                </div>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="catalog-sub-menu nav-item"
                tabindex="0"
                @click="downloadExcel()"
            >
                <div class="sub_menu_title">
                    <span>Скачати в Excel</span>
                </div>
                <svg width="12" height="15" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-19fd1ff0=""><path d="M12 10H9V0H7V10H4L8 14L12 10ZM0 16V18H16V16H0Z" fill="#356EEF" data-v-19fd1ff0=""></path></svg>
            </div>
            <div class="nav-item"
                tabindex="0"
            >
                <Checkbox v-model="sortByGroup" @change="getData" binary />
                <label class="ml-2">Сортування по групам</label>
            </div>
        </div>

        <!-- <Button icon="pi pi-external-link" label="Скачати в Excel" /> -->

        <DataTable
            :value="data"
            v-model:filters="filters"
            filterDisplay="row"
            lazy
            :loading="loading"
            @filter="handleInput"
            style="overflow: auto;"
        >
            <Column field="parent_category" header="Напрям" style="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.parent_category }}
                </template>
                <template #filter>
                    <InputText v-model="filters.parent_category.value" type="text" @input="handleInput" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="category" header="Група" style="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.category }}
                </template>
                <template #filter>
                    <InputText v-model="filters.category.value" type="text" @input="handleInput" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="brand" header="Бренд" style="min-width: 200px;" v-if="sortByGroup">
                <template #body="slotProps">
                    {{ slotProps.data.brand }}
                </template>
                <template #filter>
                    <InputText v-model="filters.brand.value" type="text" @input="handleInput" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="user" header="Відповідальний продакт-менеджер">
                <template #body="slotProps">
                    <div class="input_container">
                    <InputText class="price_input" v-model="slotProps.data.user" />
                    <Button icon="pi pi-save" class="p-button-text" aria-label="Зберегти" @click="saveUser(slotProps.data.group_category_id, slotProps.data.user, 'user', slotProps.data.brand_id)" />
                    </div>
                </template>
                <template #filter>
                    <InputText v-model="filters.user.value" type="text" @input="handleInput" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="user_asistant" header="Відповідальний асистент продакт-менеджера">
                <template #body="slotProps">
                    <div class="input_container">
                    <InputText class="price_input" v-model="slotProps.data.user_asistant" />
                    <Button icon="pi pi-save" class="p-button-text" aria-label="Зберегти" @click="saveUser(slotProps.data.group_category_id, slotProps.data.user_asistant, 'user_asistant', slotProps.data.brand_id)" />
                    </div>
                </template>
                <template #filter>
                    <InputText v-model="filters.user_asistant.value" type="text" @input="handleInput" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="total_products" header="Кільк. SKU">
                <template #body="slotProps">
                    {{ slotProps.data.total_products }}
                </template>
            </Column>
            <Column field="total_photos" header="Заповнено фото">
                <template #body="slotProps">
                    {{ slotProps.data.total_photos }}
                </template>
            </Column>
            <Column field="total_descriptions" header="Заповнено описів">
                <template #body="slotProps">
                    {{ slotProps.data.total_descriptions }}
                </template>
            </Column>
            <Column field="total_accessories" header="Заповнено аксесуарів">
                <template #body="slotProps">
                    {{ slotProps.data.total_accessories }}
                </template>
            </Column>
            <Column field="total_files" header="Заповнено документів">
                <template #body="slotProps">
                    {{ slotProps.data.total_files }}
                </template>
            </Column>
            <Column field="total_characteristics" header="Заповнено характеристик">
                <template #body="slotProps">
                    {{ slotProps.data.total_characteristics }}
                </template>
            </Column>
            <ColumnGroup type="footer" v-if="total.sku">
                <Row>
                    <Column footer="Загальна кількість:" :colspan="sortByGroup ? 5 : 4" footerStyle="text-align:right" />
                    <Column :footer="total.sku" />
                    <Column :footer="total.photo" />
                    <Column :footer="total.description" />
                    <Column :footer="total.accessory" />
                    <Column :footer="total.document" />
                    <Column :footer="total.characteristic" />
                </Row>
            </ColumnGroup>
            <template #empty>Немає результатів, оберіть бренд</template>
        </DataTable>

        <Dialog v-model:visible="isShowBrands" id="characteristics-table2" header="Бренди" modal :style="{ width: '500px' }">
            <InputText class="search_input mb-2" placeholder="Пошук за назвою" v-on:keyup="getBrandsTree()" v-model="searchBrandName" />
            <div class="flex items-center mb-2">
                <Checkbox v-model="checkedAllBrands" @change="selectAllBrads" binary name="category" />
                <label class="ml-2">Обрати всі бренди</label>
            </div>
            <template v-if="brands.length">
                <div v-for="brand of brands" :key="brand.key" class="flex items-center mb-2">
                    <Checkbox v-model="selectedBrands" @change="selectBrad" :inputId="brand.key" name="category" :value="brand.key" />
                    <label :for="brand.key" class="ml-2">{{ brand.label }} ({{ brand.products_count }})</label>
                </div>
            </template>
            <span v-else>Зачекайте..</span>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="getData()">Пошук</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isShowBrands=false">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup'
import {FilterMatchMode} from "primevue/api";
import InputText from 'primevue/inputtext';
import Row from 'primevue/row';
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import debounce from 'lodash.debounce';

export default {
    layout: AppLayout,
    data() {
        return {
            data: [],
            originalData: [],
            brands: [],
            total: {},
            sortByGroup: false,
            isShowBrands: false,
            searchBrandName: null,
            selectedBrands: [],
            progress: false,
            loading: false,
            checkedAllBrands: false,
            filters: {
                user: { value: null, matchMode: FilterMatchMode.CONTAINS },
                user_asistant: { value: null, matchMode: FilterMatchMode.CONTAINS },
                parent_category: { value: null, matchMode: FilterMatchMode.CONTAINS },
                category: { value: null, matchMode: FilterMatchMode.CONTAINS },
                brand: { value: null, matchMode: FilterMatchMode.CONTAINS },
            }
        }
    },
    components: {
        ProgressBar,
        "p-fileupload": FileUpload,
        "p-toast": Toast,
        Input,
        Button,
        DataTable,
        Column,
        ColumnGroup,
        InputText,
        Row,
        Dialog,
        Checkbox,
    },
    mounted() {
        // this.getData();
        this.getBrandsTree();
    },
    methods: {
        handleInput: debounce(function () {
            this.search();
        }, 700), // Задержка в мс
        async search() {
            // Имитация запроса на сервер
            this.searchByColumn();
        },
        searchByColumn() {
            let data = _.cloneDeep(this.originalData)
            if (this.filters.parent_category.value && this.filters.parent_category.value.length) {
                data = data.filter(data =>
                    data.parent_category.toLowerCase().includes(this.filters.parent_category.value.toLowerCase())
                )
            }
            if (this.filters.category.value && this.filters.category.value.length) {
                data = data.filter(data =>
                    data.category.toLowerCase().includes(this.filters.category.value.toLowerCase())
                )
            }
            if (this.filters.brand.value && this.filters.brand.value.length) {
                data = data.filter(data =>
                    data.brand.toLowerCase().includes(this.filters.brand.value.toLowerCase())
                )
            }
            if (this.filters.user.value && this.filters.user.value.length) {
                data = data.filter(data =>
                    data.user.toLowerCase().includes(this.filters.user.value.toLowerCase())
                )
            }
            if (this.filters.user_asistant.value && this.filters.user_asistant.value.length) {
                data = data.filter(data =>
                    data.user_asistant.toLowerCase().includes(this.filters.user_asistant.value.toLowerCase())
                )
            }

            if (!this.filters.parent_category.value && !this.filters.category.value && !this.filters.brand.value && !this.filters.user.value && !this.filters.user_asistant.value) {
                data = _.cloneDeep(this.originalData)
            }

            let totalSku = 0
            let totalPhoto = 0
            let totalDescription = 0
            let totalAccessory = 0
            let totalDocument = 0
            let totalCharacteristic = 0
            data.forEach((item, index) => {
                totalSku += item.total_products
                totalPhoto += item.total_photos
                totalDescription += item.total_descriptions
                totalAccessory += item.total_accessories
                totalDocument += item.total_files
                totalCharacteristic += item.total_characteristics
            });
            this.total.sku = totalSku
            this.total.photo = totalPhoto
            this.total.description = totalDescription
            this.total.accessory = totalAccessory
            this.total.document = totalDocument
            this.total.characteristic = totalCharacteristic

            this.data = data
        },
        getData() {
            this.loading = true
            this.isShowBrands = false
            this.filters.parent_category.value = null
            this.filters.category.value = null
            this.filters.user.value = null
            this.filters.user_asistant.value = null

            if (this.sortByGroup) {
                this.selectedBrands = []
            }

            axios.post(this.route('catalog-brand-analytics-data'), {filters: this.filters, brands: this.selectedBrands, byGroup: this.sortByGroup})
                .then((result) => {
                    this.data = result.data.data;
                    this.originalData = result.data.data;
                    this.total = result.data.total;
                    this.loading = false
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                    this.loading = false
                })
        },
        saveUser(groupId, user, type, brand_id = null) {
            axios.post(this.route('catalog-brand-analytics-user'), {group_id: groupId, user: user, brands: this.selectedBrands, type: type, brand_id: brand_id})
                .then((result) => {
                    this.originalData = _.cloneDeep(this.data)
                    this.$toast.add({severity: 'success', summary: 'Збережено', detail: 'Відповідального успішно збережено', life: 3000});
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                })
        },
        getBrandsTree() {
            axios.post(this.route('api.vector.upload-sku-groups-files.brands_tree'), {
                    name: this.searchBrandName,
                    catalog: [],
                    brands: this.selectedBrands,
                    searchval: null,
                })
                .then((result) => {
                    this.brands = result.data.data
                }).catch((error) => {
                    this.uploading = false
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                })
        },
        getSelectedBrandsNames() {
            let result = ''
            this.selectedBrands.forEach((id, index) => {
                const brand = this.brands.find(b => b.key === id);
                result += brand.label + (this.selectedBrands.length > 1 && this.selectedBrands.length !== index+1 ? ', ' : '')
            });
            return result
        },

        selectAllBrads() {
            this.selectedBrands = []

            if (this.checkedAllBrands) {
                this.brands.forEach((value, index) => {
                    this.selectedBrands.push(value.key)
                });
            }
        },
        selectBrad() {
            this.checkedAllBrands = false
        },

        downloadExcel() {
            axios.post(this.route('catalog-brand-analytics-data-download'), {
                data: this.data,
                total: this.total,
                brand: this.selectedBrands,
                byGroup: this.sortByGroup,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                alert(error);
                window.scroll(0, 0);
            })
        }
    }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
th.value {
  font-weight: 100;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
.sub_menu_title {
    display: flex;
    align-items: center;
}
.sub_menu_title span {
    margin-left: 8px;
}
.catalog-sub-menu {
    position: relative;
    min-width: 200px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    justify-content: space-between;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
    cursor: pointer;
    max-width: 100px;
}
.sub_menu_title {
    display: flex;
    align-items: center;
}
.sub_menu_title span {
    margin-left: 8px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.search_input {
    width: 100%;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 1rem;
}
.selected_pill {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #356EEF;
}
.input_container {
    display: flex;
}
</style>
